<div *ngIf="data.component === 'Policy'">
    <ng-container *ngIf="!setAsPrimaryPolicy">
        <div class="my-3 mx-2">
            <h1 mat-dialog-title>Clear Primary Policy</h1>
            <div mat-dialog-content class="my-3">
                <p>Please confirm you would like to clear this policy as primary?</p>
                <p class="my-2">The existing primary policy will be removed.</p>
            </div>
            <div mat-dialog-actions class="mt-2 d-flex justify-content-end">
                <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                    Cancel
                </button>
                <button mat-raised-button class="warn-button" (click)="onClearPrimaryPolicyClick()">
                    Clear Primary
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="setAsPrimaryPolicy">
        <div class="my-3 mx-2">
            <h1 mat-dialog-title>Set as Primary Policy</h1>
            <div mat-dialog-content class="my-3">
                <p>Please confirm you would like to set this policy as primary?</p>
                <p class="my-2">The existing primary policy will be replaced.</p>
            </div>
            <div mat-dialog-actions class="mt-2 d-flex justify-content-end">
                <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                    Cancel
                </button>
                <button mat-raised-button class="action-button" (click)="onSetAsPrimaryPolicyClick()">
                    Set as Primary
                </button>
            </div>
        </div>
    </ng-container>
</div>

<div *ngIf="data.component === 'Verification Package'">
    <ng-container *ngIf="!setAsPrimaryPackage">
        <div class="my-3 mx-2">
            <h1 mat-dialog-title>Clear Primary Verification Package</h1>
            <div mat-dialog-content class="my-3">
                <p>Please confirm you would like to clear this verification package as primary?</p>
            </div>
            <div mat-dialog-actions class="mt-2 d-flex justify-content-end">
                <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                    Cancel
                </button>
                <button mat-raised-button class="warn-button" (click)="onClearPrimaryVerificationPackageClick()">
                    Clear Primary
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="setAsPrimaryPackage">
        <div class="my-3 mx-2">
            <h1 mat-dialog-title>Set as Primary Verification Package</h1>
            <div mat-dialog-content class="my-3">
                <p>Please confirm you would like to set this verification package as primary?</p>
            </div>
            <div mat-dialog-actions class="mt-2 d-flex justify-content-end">
                <button mat-raised-button class="cancel-button" (click)="onNoClick()">
                    Cancel
                </button>
                <button mat-raised-button class="action-button" (click)="onSetAsPrimaryVerificationPackageClick()">
                    Set as Primary
                </button>
            </div>
        </div>
    </ng-container>
</div>